import LocalizedStrings from 'react-localization';

const tenantStrings = new LocalizedStrings({
  en: {
    superAdmin: {
      pageTitle: "Tenant Settings",
      sectionTitle: "Super Admin Settings",
      minuteIncrementLabel: "Minimum shift increment",
      minuteIncrementDescription: "Smallest number of minutes a shift start or end time can be changed",
      canDeleteRostersLabel: "Can Delete Rosters",
      canDeleteRostersDescription: "Whether daily rosters can be deleted",
      displayEmployeeIdsLabel: "Display Employee IDs",
      displayEmployeeIdsDescription: "Display employee IDs alongside names",
      maxCustomTemplatesLabel: "Custom template maximum",
      maxCustomTemplatesDescription: "The number of custom templates a customer can create",
      historicalDataLabel: "Historical Data Displayed For",
      historicalDataDescription: "How far back in time it is possible to display (plus the current month)",
      sectionContactsRoles: "Contacts & Roles",
      advancedContractsLabel: "Standard or Advanced",
      advancedContractsDescription: "Standard means tenant-wide settings applied to all employees. Advanced enables contacts to be defined for individual roles, which are then assigned to employees.",
      sectionLeaveSettings: "Leave Settings",
      sectionLeaveSettingsDescription:
        "Settings related to leave management features",

      leaveTypeTierLabel: "Leave Type Tier",
      leaveTypeTierDescription:
        "Select which plan this tenant uses",
      leaveTypeTierStandard: "Standard",
      leaveTypeTierAdvanced: "Advanced",

      sectionAdvancedProperties: "Optimiser Parameters",
      sectionAdvancedPropertiesDescription: "Use with caution",

      optimiserDurationLabel: "Optimiser runtime duration",
      optimiserDurationDescription:
        "Number of seconds the optimiser will run (assembling/disassembling the payload isn't included in the timeframe!)",

      optimiserManagementAttendanceLabel: "Management persona in attendance",
      optimiserManagementAttendanceDescription: "Hard constraint to force attendance for at least one shift per roster",
      sectionFeatureAvailability: "Feature Availability",
      sectionFeatureAvailabilityDescription: "Enable or disable tenant-facing product areas when they are available in backstage.",
      clockInOutLabel: "Clock in and out",
      clockInOutDescription: "Controls the clock in and out experience for this tenant.",
      payLabel: "Pay",
      payDescription: "Controls pay-related displays and editing for this tenant.",
      featureDefault: "Use backstage default",
      featureEnabled: "Enabled",
      featureDisabled: "Disabled",
      featureDisabledByBackstage: "Disabled by backstage"
    },
    admin: {
      pageTitle: "Tenant Settings",
      sectionWorkingTimeRules: "Working Time Rules",
      sectionWorkingTimeRulesDescription:
        "Rules related to working hours and breaks",
      sectionEssBehaviour: "ESS Behaviour",
      sectionEssBehaviourDescription:
        "Controls whether ESS users can update their own contact details.",
      sectionHolidaySettings: "Holiday Settings",
      sectionHolidaySettingsDescription:
        "Choose the default holiday region for this tenant.",
      sectionOptimisationSettings: "Optimisation",
      sectionOptimisationSettingsDescription:
        "Choose which optimisation solver configuration can be used for this tenant and whether Optimisation Evaluation is available on Rosters.",

      minMinutesBeforeBreakLabel:
        "Minimum working minutes before a break",
      minMinutesBeforeBreakDescription:
        "Specify the minimum amount of time an employee must work before becoming eligible for a break.",

      minMinutesAfterBreakLabel:
        "Minimum working minutes after a break",
      minMinutesAfterBreakDescription:
        "Specify the minimum amount of time an employee must work after becoming eligible for a break.",

      shortestBreakLabel: "Shortest break",
      shortestBreakDescription:
        "Specify the minimum duration of a break",

      defaultHolidayRegionCodeLabel: "Default holiday region",
      defaultHolidayRegionCodeDescription:
        "Used as the tenant's default holiday region.",
      defaultHolidayRegionCodeEnglandAndWales: "England & Wales",
      defaultHolidayRegionCodeScotland: "Scotland",
      defaultHolidayRegionCodeNorthernIreland: "Northern Ireland",
      defaultHolidayRegionCodeIreland: "Eire",
      allowEssEditEmailLabel: "Allow ESS to edit own email",
      allowEssEditEmailDescription:
        "If enabled, ESS users can update their own email address from their profile.",
      allowEssEditPhoneNumberLabel: "Allow ESS to edit own phone number",
      allowEssEditPhoneNumberDescription:
        "If enabled, ESS users can update their own phone number from their profile.",
      enabledSolversLabel: "Enabled solver",
      enabledSolversDescription:
        "Choose whether this tenant uses Genetic Algorithm, CP-SAT, or allows both.",
      optimisationEvaluationLabel: "Show Optimisation Evaluation",
      optimisationEvaluationDescription:
        "Controls whether the Optimisation Evaluation button and modal are available on the Rosters page.",
      enabledSolversGeneticAlgorithm: "Genetic Algorithm",
      enabledSolversCpSat: "CP-SAT",
      enabledSolversBoth: "Genetic Algorithm and CP-SAT",
    }
  }
});

export default tenantStrings;
